import React, { useState } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const PriceRange = () => {
    const initialRange = [24500, 27000]
    const [range, setRange] = useState(initialRange);

    const handleChange = (newValue) => {
        setRange(newValue);
    };

    const handleReset = () => {
        setRange(initialRange);
    };

    return (
        <div style={{ margin: '20px' }}>
            <Slider
                min={24500}
                max={27000}
                step={1}
                range
                value={range}
                onChange={handleChange}
            />
            <div style={{ marginTop: '10px' }}>
                Range: {"Rs" + range[0]} - {"Rs" + range[1]}
            </div>
            <button onClick={handleReset}>Reset</button>
        </div>
    );
}

export default PriceRange